import Vue from 'vue';
import Toastify from 'toastify-js';

export default Vue.mixin({
  methods: {
    toastify(text, className = 'success', duration = 2000, close = true) {
      Toastify({
        text,
        duration,
        close,
        gravity: 'bottom',
        position: 'left',
        stopOnFocus: true,
        className: `${className} ${close ? 'close' : ''}`,
      }).showToast();
    },
  },
});
